export interface Logger {
  application: string;
  sessionUniqueId: string;
  url: string;
  type: LoggerTypeEnum;
  timestamp: number;
  duration: string;
  code?: number;
  method?: string;
  contentType?: string;
  request: LoggerRequest;
  response?: LoggerResponse;
  error?: LoggerError;
}

export interface LoggerRequest {  
  method?: string;
  urlWithParams?: string;
  body: any;
  headers: any;
  parameters?: any;
  responseType?: string;
}

export interface LoggerResponse {
  ok?: boolean;
  status: number;
  statusText?: string;
  headers?: any;
  error?: any;
  message?: string;
  body: any;
}

export interface LoggerError {
  ok: boolean;
  headers: any;
  status: number;
  message: string;
  error: any;
}

export enum LoggerTypeEnum {
  REQUEST = 'REQUEST',
  RESPONSE = 'RESPONSE',
  ERROR = 'ERROR',
}

export interface PostDpopResponse {
  token: string;
  exp: string;
}